module.exports = __webpack_public_path__ + "media/images/lb/538-8a00511a55732aada10219bb180e395d.svg";